import React from 'react';
import { translate } from 'react-i18next';

import * as Subaccount from 'subaccounts/components/form';
import * as Common from 'common/components';

const SubaccountFormView = ({
  t,
  subaccount,
  accounts,
  company,
  depreciations,
  handleAddCustomField,
  handleRemoveCustomField,
  handleSubmit,
  handleValueChange,
  handleValidation,
  subcompany,
  isFetching,
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  groups, //Groups
  isSubmitted,
  isSaving,
}) => (
  <Common.Wrapper fluid={true}>
    {/* <Common.Header title={t("subaccounts.subaccounts_title")} /> */}
    <div className="col-12">
      <Common.Portlet
        title={
          t('menu.configuration') +
          ' > ' +
          t('subaccounts.subaccounts_title') +
          ' > ' +
          t(subaccount.id ? 'subaccounts.edit' : 'subaccounts.add')
        }
        icon={'archive'}
      >
        <Subaccount.Form
          accounts={accounts}
          company={company}
          depreciations={depreciations}
          handleAddCustomField={handleAddCustomField}
          handleRemoveCustomField={handleRemoveCustomField}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isSubmitted={isSubmitted}
          isSaving={isSaving}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={groups} //Groups
          subcompany={subcompany}
          values={subaccount}
        />
        <Common.LoaderOverlay show={isFetching} />
      </Common.Portlet>
    </div>
  </Common.Wrapper>
);

export default translate()(SubaccountFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/components/SubaccountFormView.js